// Flow types automatically removed

import { createElement } from 'react';
import { hydrateRoot } from 'react-dom/client';
import SV from 'server-vars';
import { IntlProvider } from 'dibs-react-intl';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { getEnvironment } from '../relayModernEnvironment.ts';
import { DesignerDirectoryContainer } from '../designerDirectory/DesignerDirectoryContainer.jsx';
const locale = SV.get('locale');
const useCustomEnv = !!SV.get('useCustomRelayEnvironment');
initializeDBL().then(() => {
    const DesignerDirectory = createElement(DesignerDirectoryContainer, {
        environment: getEnvironment(!useCustomEnv),
    });
    const containerElement = document.getElementById('js-root');

    if (containerElement !== null) {
        hydrateRoot(
            containerElement,
            createElement(
                IntlProvider,
                {
                    locale,
                    disableTranslations: true,
                },
                DesignerDirectory
            )
        );
    } else {
        // eslint-disable-next-line no-console
        console.error('Could not mount React due to missing #js-root element');
    }
});
